export default __webpack_public_path__ + "static/media/aboutImage.6fc0d8f5.jpg";